import { getTestPort } from "@/utils/common";
const VUE_APP_URL_API = getTestPort();
const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async invalidateCoupon({ rootState, commit }, params = {}) {
      const data = await rootState.http(VUE_APP_URL_API + "/promotion/coupon/store/manual/verification", params);
      return data;
    }
  }
};

export default store;
